export default __webpack_public_path__ + "static/media/bs4.1.0668413a.png";